import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["scroller", "active"];

  connect() {
    requestAnimationFrame(() => {
      // Keep the current tab visible in the horizontal scroller (otherwise it
      // resets to the first tab on every navigation).
      this._scrollActiveTabIntoScroller();
    });
  }

  _scrollActiveTabIntoScroller() {
    if (!this.hasActiveTarget || !this.hasScrollerTarget) return;

    const scroller = this.scrollerTarget;
    const active = this.activeTarget;
    const left = active.offsetLeft - (scroller.clientWidth - active.offsetWidth) / 2;
    scroller.scrollLeft = Math.max(0, left);
  }
}
